import { FormService } from '@/services/form.service';

export default {
  namespaced: true,

  state: {
    show: false,
    create: false,
    eventForms: [],
    forms: [],
    form: null,
    formInterval: null,
  },

  getters: {
    show: state => state.show,
    create: state => state.create,
    forms: state => state.forms,
    form: state => state.form,
  },

  mutations: {
    toggleForms(state, bool) {
      state.show = bool;
    },
    toggleCreate(state, bool) {
      state.create = bool;
    },
    setForms(state, forms) {
      state.forms = forms;
    },
    setForm(state, form) {
      state.form = form;
    },
    pushEventForm(state, form) {
      state.eventForms.push(form);
    },
    clearEventForms(state) {
      state.eventForms = [];
    },
  },

  actions: {
    /**
     * Get a list of forms
     * @param {Object} param0
     * @param {Object} param1
     * @returns {Array}
     */
    // eslint-disable-next-line
    getAllForms: async ({}, params = {}) => {
      let payload = {
        page: 1,
        per_page: 20,
        expand: 'broadcast',
      };

      payload = { ...payload, ...params };

      try {
        const forms = await FormService.listAll(payload);
        return forms;
      } catch (e) {
        return false;
      }
    },
    getForms: async ({ commit }, { id, clear = false }) => {
      if (clear) {
        commit('setForms', []);
      }

      try {
        const forms = await FormService.list(id);
        if (forms.length > 0) {
          // eslint-disable-next-line
          for (let form of forms) {
            // eslint-disable-next-line
            const submissions = await FormService.getSubmissions(form.id);
            form.submissions = submissions;
          }
        }
        commit('setForms', forms);
        return true;
      } catch (e) {
        return false;
      }
    },
    getForm: async ({ commit }, { id, doCommit = true }) => {
      try {
        const form = await FormService.get(id);
        const submissions = await FormService.getSubmissions(form.id);
        form.submissions = submissions;

        if (doCommit) {
          commit('setForm', form);
          return true;
        }
        return form;
      } catch (e) {
        if (doCommit) {
          commit('setForm', null);
          return false;
        }
        return null;
      }
    },
    // eslint-disable-next-line
    getFormSubmissions: async (_, id) => {
      try {
        const submissions = await FormService.getSubmissions(id);
        return submissions;
      } catch (e) {
        return [];
      }
    },
    createForm: async ({ commit }, payload) => {
      try {
        const form = await FormService.create(payload);
        commit('setForm', form);
        return true;
      } catch (e) {
        return false;
      }
    },
    updateForm: async ({ commit }, { id, payload }) => {
      try {
        const form = await FormService.update(id, payload);
        commit('setForm', form);
        return true;
      } catch (e) {
        return false;
      }
    },
    // eslint-disable-next-line
    deleteForm: async({ }, id) => {
      try {
        await FormService.delete(id);
        return true;
      } catch (e) {
        return false;
      }
    },
    // eslint-disable-next-line
    promoteForm: async({}, id) => {
      try {
        await FormService.promote(id);
        return true;
      } catch (e) {
        return false;
      }
    },
    exportSubmissions: async (_, id) => {
      try {
        const data = await FormService.exportSubmissions(id);
        return data;
      } catch (e) {
        return false;
      }
    },
    handleEvents: async ({ commit, state }, { id, events }) => {
      events.forEach((event) => {
        if (event.event === 'form.deleted') {
          commit('Chat/removeMessageByPayloadId', {
            chatId: id,
            payloadId: event.payload.id,
          }, { root: true });
          return;
        }

        if (event.payload.title) {
          commit('pushEventForm', event.payload);
        }

        const [form] = state.eventForms.filter(f => f.id === event.payload.id);

        if (!form) {
          return;
        }
        let messageState = '';

        switch (event.event) {
          case 'form.published':
            messageState = 'published';
            break;
          case 'form.completed':
            messageState = 'completed';
            break;
          case 'form.promoted':
            messageState = 'promoted';
            break;
          default:
            break;
        }

        commit('Chat/addMessage', {
          id,
          message: {
            message_id: event.message_id,
            event: event.event,
            timestamp: event.timestamp,
            message: `${form.title} ${messageState}`,
            payload_id: event.payload.id,
          },
        }, { root: true });
      });
    },
  },

};
